import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { SectionsService } from '../../../../services/sections.service';
import { ReferralDataService } from '../../../../services/referral-data.service';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { ProcessCode } from '../../../../interfaces/payroll.model';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { ClaimsService } from '../../../../services/claims.service';
import { UserService } from '../../../../services/user.service';
import { AutoFocusHeaderDirective } from '../../../../shared/directives/auto-focus-header.directive';

@Component({
  selector: 'ppl-process-code-list',
  standalone: true,
  imports: [ListTableComponent, AutoFocusHeaderDirective],
  templateUrl: './process-code-list.component.html',
  styleUrl: './process-code-list.component.css',
})
export class ProcessCodeListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_PROCESS_CODE_DATA;
  pageId: string = PAGE_CONSTANTS.PROCESS_CODE_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  programName!: string;
  lazyLoad = true;

  constructor(private router: Router, private sectionService: SectionsService, private referralDataService: ReferralDataService,
    private userService: UserService, private sharedDataService: SharedDataService, private authUtility: AuthorizationUtility,
    private authService: AuthorizationService, private claimsService: ClaimsService
  ) {
  }

  onAddProcessCode() {
    this.sectionService.setFlow('processCode');
    this.router.navigate(['/home/processCode', 'add']);
  }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  rowClicked(rowDetail: ProcessCode) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('processCode');
    this.sectionService.setFlow('processCode');
    this.userService.setSelectedLead(rowDetail.processCodeDetailId);
      this.claimsService.fetchClaimsData(
          program?.program_code ?? '',
          rowDetail.processCodeDetailId,
          'processCode'
        )
        .subscribe((data: any) => {
          this.claimsService.setFormData('process_code', data.responsedata);
          setTimeout(() => {
            this.router.navigate(['/home/processCode', 'update']);
          }, 200);
        });
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService.fetchPageAuthorization(this.programName, this.pageId, "LIST").subscribe(response => {
        this.setRestrictions(response);
      })
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(pageConfig, this.pageId);
      this.actionsToBeHidden = this.authUtility.getHiddenActions(pageConfig, this.pageId);
    }
    this.isPageRestrictionLoaded = true;
  }

  clearData() {
    this.sharedDataService.clearData(this.sharedDataKey);
  }
  
}
